//@ts-nocheck
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
import { rounded_rect } from '../../utils/graphUtils'

type PropTypes = {
  data: {
    month: number
    value: number
    label: string
  }[]
  showLabels: boolean
  onRankChange: Function
}

const RankGraphUnavailable = () => {
  const svgRef = useRef<SVGSVGElement>(null)
  const [width, setWidth] = useState(window.innerWidth - 40)
  const height = 217

  useEffect(() => {
    const handleResize = () => {
      const parentWidth = (svgRef.current?.parentNode as HTMLElement)?.clientWidth ?? 0
      const parentHeight = (svgRef.current?.parentNode as HTMLElement)?.clientHeight ?? 250
      setWidth(parentWidth)
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [width])

  useEffect(() => {
    const margin = { top: 0, right: 0, bottom: 30, left: 0 }
    const chartWidth = width - margin.left - margin.right
    const chartHeight = height - margin.top - margin.bottom

    const svg = d3
      .select(svgRef.current)
      .attr('width', chartWidth - margin.left - margin.right)
      .attr('height', chartHeight + margin.top + margin.bottom)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`)

    const xScale = d3
      .scalePoint()
      .range([20, chartWidth - 15])
      .padding(0.5)

    const yScale = d3.scaleLinear().range([chartHeight, 0])

    const colorRanges = ['#E6F2FF', '#BFDFFF', '#96C8FA', '#6DB0F2']
    colorRanges.reverse()
    const numOfVerticalSections = colorRanges.length
    const sectionHeight = chartHeight / numOfVerticalSections

    colorRanges.forEach((color, i) => {
      svg
        .append('path')
        .attr('d', (d) => {
          return rounded_rect(0, i * sectionHeight, chartWidth - 1, sectionHeight, 11.5, i == 0, i == 0, false, false)
        })
        .attr('fill', color)
    })

    svg.select('.domain').attr('stroke', 'none')
    const line = d3
      .line()
      .x((d) => xScale(d.month))
      .y((d) => yScale(d.value))

    // Centered pill
    const pillGroup = svg.append('g').attr('transform', `translate(${chartWidth / 2}, ${chartHeight / 2})`)

    // Background for the pill
    pillGroup
      .append('rect')
      .attr('x', -70) // Adjust based on text width
      .attr('y', -15) // Adjust to center vertically
      .attr('width', 140) // Adjust based on text width
      .attr('height', 30)
      .attr('rx', 15) // Rounded corners
      .attr('ry', 15)
      .attr('fill', '#ffffff')
      .attr('stroke', '#ffffff')
      .attr('stroke-width', 0.5)

    // Text inside the pill
    pillGroup
      .append('text')
      .text('Graph unavailable')
      .attr('font-size', '12px')
      .attr('font-weight', 'bold')
      .attr('fill', '#333333')
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'middle')

    return () => {
      d3.select(svgRef.current).selectAll('*').remove()
    }
  }, [])

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <svg style={{ borderRadius: '12px', border: '0.5px solid #8E93933A', overflow: 'visible' }} ref={svgRef}></svg>
      <div className='text-13 text-grey40 leading-[20.8px] mt-4'>
        Graph data is not available right now, please retry later.
      </div>
    </div>
  )
}

export default RankGraphUnavailable
